import { render, staticRenderFns } from "./ProgrammesBar.vue?vue&type=template&id=aad8ae10&"
import script from "./ProgrammesBar.vue?vue&type=script&lang=js&"
export * from "./ProgrammesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports